import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { BrowserRouter, Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { Route, Switch } from 'react-router'
import { auth } from '../../config/constants/database'
import { CookiesProvider } from 'react-cookie'
import { bindActionCreators } from 'redux'
import axios from 'axios'
import ReactGA from 'react-ga'

// Styles
import withRoot from '../../assets/styles/root/withRoot'

// Scenes
import GetStarted from '../../scenes/GetStarted'
import Dashboard from '../../scenes/Dashboard'
import Information from '../../scenes/Information'
import Login from '../../scenes/Login'

// Spinner
import Loader from '../Loader'

import { setCustomerNumber, setCustomerEmail } from './actions'

function PrivateRoute({ component: Component, authed, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        authed === true ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: '/login', state: { from: props.location } }}
          />
        )
      }
    />
  )
}

function PublicRoute({ component: Component, authed, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        authed === false ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  )
}

const ConnectedSwitch = connect(state => ({
  location: state.location
}))(Switch)

class CoreLayout extends Component {
  constructor(props) {
    super(props)

    this.state = {
      authed: false,
      loading: true
    }
  }

  componentDidMount() {
    let myComponent = this
    ReactGA.initialize('UA-122485379-1')
    ReactGA.pageview(window.location.pathname + window.location.search)
    this.removeListener = auth().onAuthStateChanged(user => {
      if (user) {
        if (user.uid) {
          axios
            .get(`https://api.dsnapis.com/firebase/${user.uid}/pw/teSt1`)
            .then(function(response) {
              if (Array.isArray(response.data)) {
                if (response.data[0]['Cust_ID']) {
                  console.log(response.data)
                  let customerNumber = response.data[0]['Cust_ID']
                  myComponent.props.setCustomerNumber(customerNumber)
                  myComponent.props.setCustomerEmail(user.email)

                  myComponent.setState({
                    authed: true,
                    loading: false
                  })
                } else {
                  window.location.reload()
                }
              } else {
                window.location.reload()
              }
            })
        }

        // Set Customer Number here
        console.log(user.uid)
      } else {
        this.setState({
          authed: false,
          loading: false
        })
      }
    })
  }
  componentWillUnmount() {
    this.removeListener()
  }

  render() {
    const { classes, theme, location, customer_number } = this.props
    if (this.state.loading == true) {
      return <Loader />
    } else {
      return (
        <CookiesProvider>
          <ConnectedSwitch>
            <PrivateRoute
              authed={this.state.authed}
              exact
              path="/"
              component={GetStarted}
            />
            <PublicRoute
              authed={this.state.authed}
              path="/login"
              component={Login}
            />
            <PrivateRoute
              authed={this.state.authed}
              path="/console"
              component={Dashboard}
            />
            <PrivateRoute
              authed={this.state.authed}
              path="/information"
              component={Information}
            />
            <Route render={() => <h3>404 - Page Not Found</h3>} />
          </ConnectedSwitch>
        </CookiesProvider>
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id
  }
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setCustomerNumber: setCustomerNumber,
      setCustomerEmail: setCustomerEmail
    },
    dispatch
  )
}

export default withRoot(
  withRouter(connect(mapStateToProps, matchDispatchToProps)(CoreLayout))
)



// WEBPACK FOOTER //
// ./src/components/CoreLayout/index.js